import type { PropsWithChildren } from "react";

type Props = PropsWithChildren;

export default function CheckoutContainer(props: Props) {
  const { children } = props;

  return (
    <section className="border-grey-150 relative flex flex-1 flex-col divide-y border-b md:pb-12">
      {children}
    </section>
  );
}
